import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import {
  previewRegistrationRequests,
  sendRegistrationRequests
} from '../requests/communication.request';
import {
  RegistrationRequestPreviewResponse,
  RegistrationRequestSend,
  RegistrationRequestSendResponse
} from '../types/communication.types';

export const usePreviewRegistrationRequestsMutation = () => {
  return useMutation<
    RegistrationRequestPreviewResponse | undefined,
    AxiosError,
    RegistrationRequestSend
  >({
    mutationKey: ['preview-registration-requests'],
    mutationFn: previewRegistrationRequests,
    onError: (error) => {
      toast.error(error.message || 'Could not build the preview');
    }
  });
};

export const useSendRegistrationRequestsMutation = () => {
  return useMutation<
    RegistrationRequestSendResponse | undefined,
    AxiosError,
    RegistrationRequestSend
  >({
    mutationKey: ['send-registration-requests'],
    mutationFn: sendRegistrationRequests,
    onError: (error) => {
      toast.error(error.message || 'Could not send the registration requests');
    }
  });
};
